export default "__VITE_ASSET__BBybwkOE__"